module.exports = __webpack_public_path__ + "img/hr-green-hairy-grass-01.596220b2.png";